import type { CMYKColor } from "../types/colors/CMYKColor"
import type { Color } from "../types/colors/Color"
import type { RGBColor } from "../types/colors/RGBColor"

/**
 * Creates a color conversion function that converts any Color to type T
 * Uses type-safe discrimination based on color properties
 */
export const CreateColorConvert =
  <T>(
    rgb: (color: RGBColor) => T,
    cmyk: (color: CMYKColor) => T
  ): ((color: Color) => T) =>
  (color: Color): T => {
    if ("red" in color) {
      return rgb(color)
    } else {
      return cmyk(color)
    }
  }
